import { Clamp } from '@crehana/compass.ui';
import { useProfileUITranslations } from "../../i18n";
import Subtitle from "../Subtitle";
import { useGetUserLearningDetailQuery } from "./hooks/graphql/get-user-learning-detail.v4.b2b.generated";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export var HeaderSwitcher = function HeaderSwitcher(_ref) {
  var _data$organizationUse, _data$organizationUse2, _data$organizationUse3, _data$organizationUse4, _data$organizationUse5, _data$organizationUse6, _data$organizationUse7, _data$organizationUse8;
  var mainUserId = _ref.mainUserId,
    organizationSlug = _ref.organizationSlug;
  var _useProfileUITranslat = useProfileUITranslations(),
    t = _useProfileUITranslat.t;

  /**
   * This request and values should be replaced
   * with the information from metadata when are ready
   */
  var _useGetUserLearningDe = useGetUserLearningDetailQuery({
      variables: {
        userIds: [mainUserId],
        organizationSlug: organizationSlug
      },
      context: {
        clientName: 'v4.b2b'
      }
    }),
    data = _useGetUserLearningDe.data,
    loading = _useGetUserLearningDe.loading;
  var name2 = data === null || data === void 0 ? void 0 : (_data$organizationUse = data.organizationUsers) === null || _data$organizationUse === void 0 ? void 0 : (_data$organizationUse2 = _data$organizationUse.edges[0]) === null || _data$organizationUse2 === void 0 ? void 0 : (_data$organizationUse3 = _data$organizationUse2.node) === null || _data$organizationUse3 === void 0 ? void 0 : (_data$organizationUse4 = _data$organizationUse3.user) === null || _data$organizationUse4 === void 0 ? void 0 : _data$organizationUse4.fullName;
  var email2 = data === null || data === void 0 ? void 0 : (_data$organizationUse5 = data.organizationUsers) === null || _data$organizationUse5 === void 0 ? void 0 : (_data$organizationUse6 = _data$organizationUse5.edges[0]) === null || _data$organizationUse6 === void 0 ? void 0 : (_data$organizationUse7 = _data$organizationUse6.node) === null || _data$organizationUse7 === void 0 ? void 0 : (_data$organizationUse8 = _data$organizationUse7.user) === null || _data$organizationUse8 === void 0 ? void 0 : _data$organizationUse8.email;

  // biome-ignore lint/style/useBlockStatements: single-line early return
  if (loading) return null;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs("div", {
      className: "tw-mb-1.6",
      children: [/*#__PURE__*/_jsx(Subtitle, {
        label: t('SWITCHER_EXIT_MY_ACCOUNT')
      }), /*#__PURE__*/_jsx("div", {
        className: "tw-flex tw-gap-1 tw-align-center tw-justify-start tw-min-w-0",
        children: /*#__PURE__*/_jsxs("div", {
          className: "tw-flex tw-flex-col tw-items-start tw-justify-start tw-gap-0.4 tw-min-w-0",
          children: [/*#__PURE__*/_jsx(Clamp, {
            lines: 1,
            className: "tw-text-left tw-font-subtitle5 tw-w-full dark:tw-text-neutral-light-100",
            children: name2
          }), /*#__PURE__*/_jsx(Clamp, {
            lines: 1,
            className: "tw-text-left tw-font-body5 tw-text-neutral-light-700 dark:tw-text-neutral-dark-500 tw-w-full",
            children: email2
          })]
        })
      })]
    })
  });
};